 document.addEventListener("DOMContentLoaded", function () {
    let previous_selected = null;

    const containers = document.querySelectorAll(".sub_cat_main_container");

    containers.forEach(function (container) {
        container.addEventListener("click", function () {
            if (previous_selected) {
                const anchor = previous_selected.querySelector("a");
                const subCatMain = previous_selected.querySelector(".sub_cat_main");

                if (anchor && subCatMain) {
                    const category_img_height = anchor.clientHeight;

                    previous_selected.style.height = category_img_height + "px";
                    subCatMain.style.height = "0px";

                    if (previous_selected.hasAttribute("hasopenend")) {
                        previous_selected.removeAttribute("hasopenend");
                        previous_selected = null;
                        return;
                    } else {
                        previous_selected.removeAttribute("hasopenend");
                    }
                }
            }

            previous_selected = container;
            container.setAttribute("hasopenend", "yes");

            const anchor = container.querySelector("a");
            const subCatMain = container.querySelector(".sub_cat_main");

            if (anchor && subCatMain) {
                const category_img_height = anchor.clientHeight;
                const ul = subCatMain.querySelector("ul");
                const category_ul_height = ul ? ul.clientHeight : 0;

                container.style.height = (category_img_height + category_ul_height) + "px";
                subCatMain.style.height = category_ul_height + "px";
            }
        });
    });
});